module.exports = __webpack_public_path__ + "static/img/pickup-singlecab-blue.d27fab9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/pickup-singlecab-blue.svg
// module id = 1l8Y
// module chunks = 82